import axios from 'axios'
import {location} from './Location.js'


const url = location('api/links/')

  class LinkService {

  // Get Posts
  static getLinks() {
    return new Promise ((resolve,reject) => {
      axios.get(url).then((res) => {
        const data = res.data;
        resolve(
          data.map(post => ({
            ...post,
            createdAt: new Date(post.createdAt)
          }))
        );
      })
        .catch((err)=> {
          reject(err);
        })
    });
  }

  // Create Posts
  static insertLink(link){
    return axios.post(url, {
      room: link.room.id,
      title: link.title,
      link: link.link,
      isURL: link.isURL
    })
  }

 // Delete Posts
  static deleteLink(id){
    return axios.delete(`${url}${id}`)
  }
}

export default LinkService
